/// <reference types="vite/client" />
import "./style.css";
import lottie from "lottie-web/build/player/lottie_light";
import ekg from "./animations/ekg.json";

const root = document.documentElement;
root.classList.add("js");

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// (1) Hero EKG — swap the static SVG for the seamless Lottie loop when motion is
// allowed. The static SVG is the floor: it's only hidden once Lottie confirms a
// render (DOMLoaded), and is restored if Lottie fails — synchronously (throw) or
// asynchronously (data_failed/error events the try/catch can't see). A malformed
// ekg.json must never leave an empty hero.
function initEkg(): void {
	if (prefersReducedMotion) return;
	const host = document.querySelector<HTMLElement>("[data-ekg-anim]");
	const staticSvg = document.querySelector<SVGElement>(".ekg__static");
	if (!host) return;

	const restoreStaticFloor = (anim?: { destroy: () => void }): void => {
		anim?.destroy();
		host.hidden = true;
		staticSvg?.removeAttribute("hidden");
	};

	try {
		host.hidden = false;
		const anim = lottie.loadAnimation({
			container: host,
			renderer: "svg",
			loop: true,
			autoplay: true,
			animationData: ekg,
		});
		anim.addEventListener("DOMLoaded", () => {
			staticSvg?.setAttribute("hidden", "");
		});
		anim.addEventListener("data_failed", () => restoreStaticFloor(anim));
		anim.addEventListener("error", () => restoreStaticFloor(anim));
	} catch {
		restoreStaticFloor();
	}
}

// (7) Scroll reveal — sections fade + rise on first viewport entry.
function initScrollReveal(): void {
	if (prefersReducedMotion) return;
	const revealables = document.querySelectorAll<HTMLElement>(".reveal");
	if (!("IntersectionObserver" in window)) {
		for (const el of revealables) el.classList.add("is-visible");
		return;
	}
	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-visible");
					observer.unobserve(entry.target);
				}
			}
		},
		{ rootMargin: "0px 0px -10% 0px", threshold: 0.05 },
	);
	for (const el of revealables) observer.observe(el);
}

initEkg();
initScrollReveal();
